<template>
    <a href="#" 
       @click.prevent="followUser" 
       :class="{ 'pointer-events-none': isProcessing }"
       class="text-blue-500">
        {{ isProcessing ? 'Processing...' : linkText }}
    </a>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        userId: {
            required: true,
            type: Number
        },
        follows: {
            required: true,
            type: Boolean
        }
    },
    
    data() {
        return {
            status: this.follows,
            isProcessing: false
        };
    },

    methods: {
        async followUser() {
            if (this.isProcessing) return;
            
            this.isProcessing = true;
            try {
                const response = await axios.post(`/follow/${this.userId}`, {}, {
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                });

                if (response.data.success) {
                    this.status = response.data.follows;
                    this.$emit('followers-updated', response.data.followersCount);
                    window.location.reload();
                }
            } catch (error) {
                console.error('Follow error:', error.response?.data || error);
                if (error.response?.status === 401) {
                    window.location = '/login';
                }
            } finally {
                this.isProcessing = false;
            }
        }
    },

    computed: {
        linkText() {
            return this.status ? "Unfollow" : "Follow";
        }
    }
};
</script>
